import { createSlice } from '@reduxjs/toolkit';

export const factoringSetupSlice = createSlice({
  name: 'factoringSetup',
  initialState: {
    name: '',
    address: {
      street: '',
      city: '',
      stateProvince: '',
      postalCode: '',
      country: '',
    },
    logo: '',
  },
  reducers: {
    updateFactoringCompany: (state, action) => {
      state.name = action.payload.name;
      state.address = action.payload.address;
      state.logo = action.payload.logo;
    },
    updateAddress: (state, action) => {
      state.address = action.payload.address;
    },
  },
});

export const { updateFactoringCompany, updateAddress } = factoringSetupSlice.actions;

export default factoringSetupSlice.reducer;
